<template>
  <div class="p-5 base-bg">
    <div class="w-full h-full flex flex-col justify-center">
      <img
        src="../../assets/shipo-undraw-404.svg"
        class="w-1/2 self-center"
      >
      <p class="mt-5 self-center text-2xl">
        Oops... we can't found that page
      </p>
      <vs-button
        type="filled"
        color="primary"
        icon="arrow_back"
        class="w-48 mt-5 self-center"
        :disabled="preventRedundantNavigation"
        @click="$router.push({ name: havePermission ? havePermission.firstRouteThatHaveAccess : '' })"
      >
        Back to Home
      </vs-button>
    </div>
  </div>
</template>

<script>
import { PAGE_TITLE } from '@/fixtures/Constants'
import { isUserCanAccessFeature } from '@/utils/permissionUtils'

export default {
  metaInfo: {
    title: `${PAGE_TITLE} Not Found`
  },
  computed: {
    havePermission () {
      return isUserCanAccessFeature()
    },
    preventRedundantNavigation () {
      return this.havePermission.firstRouteThatHaveAccess === this.$route.name
    }
  }

}
</script>

<style lang="scss" scoped>
.base-bg {
  background-color: #F1F1FD;
}

.round-img {
  border-radius: 50%;
}
</style>
